var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var device = require( '../../scripts/src/lib/device.js' );
require('fittext');

function PageHeroFull(el) {
  this.$el = $(el);
  this.$video = this.$el.find('video');
  this.$mute = this.$el.find('.volume-on-off');
  var $contentArea = this.$el.find('.content-area');

  if(this.$video.length) {
    $(window).one('vsc-page-ready', function() {
      this.$video[0].play();
    }.bind(this));
  } else if($contentArea.attr('data-heading-animation') && !$contentArea.data('no-fit-text')) {
    this.$el.find('h1').fitText(0.5);
  }

  $('body').on('click', '.scroll-down', function(event) {

    event.preventDefault();

    var $target = $(event.target).closest('.page-hero-full').next();

    var $scroll = $('html').hasClass('css-parallax') ? $('body > main') : $('html,body');

    var top = $target.offset().top-$('.global-nav').height();

    $scroll.animate({
      'scrollTop': top
    }, 450);
  });

  if ( device.isDefinitelyMobile ) {
    this.$mute.remove();
  } else {
    this.$mute.on( "click", function() {
      this.$mute.toggleClass( "js-volume-on" );
      this.$video.prop( "muted", function(i, val) {
        return !val;
      });
    }.bind(this));
  }
}

module.exports = PageHeroFull;
